// new.prop: porównywarka materacy. Wybór trzymany w localStorage, żeby działał między stronami kategorii.
if (!customElements.get('np-compare')) {
  customElements.define('np-compare', class extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max || '3', 10);
      this.key = 'np-compare-v1';
      this.tray = this.querySelector('[data-np-cmp-tray]');
      this.list = this.querySelector('[data-np-cmp-items]');
      this.count = this.querySelector('[data-np-cmp-count]');
      this.go = this.querySelector('[data-np-cmp-go]');
      this.dialog = this.querySelector('[data-np-cmp-dialog]');
      this.body = this.querySelector('[data-np-cmp-body]');
      this.hidden = false;
      this.items = this.load();

      document.addEventListener('change', (e) => {
        const box = e.target.closest('[data-np-compare-toggle]');
        if (box) this.toggle(box.value, box.checked, box);
      });
      document.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-np-compare-open]');
        if (opener) { e.preventDefault(); this.items.length >= 2 ? this.open() : this.hint(); }
      });
      this.querySelector('[data-np-cmp-clear]').addEventListener('click', () => { this.items = []; this.save(); this.render(); });
      this.go.addEventListener('click', () => this.open());
      this.querySelector('[data-np-cmp-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      this.querySelector('[data-np-cmp-diff]').addEventListener('change', (e) => this.dialog.classList.toggle('only-diff', e.target.checked));
      this.list.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-remove]');
        if (btn) this.toggle(btn.dataset.remove, false);
      });
      // Filtry i paginacja podmieniają siatkę: odśwież zaznaczenia.
      new MutationObserver(() => this.syncBoxes()).observe(document.body, { childList: true, subtree: true });
      this.render();
    }

    load() {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    }

    save() {
      try { localStorage.setItem(this.key, JSON.stringify(this.items)); } catch (e) { /* tryb prywatny */ }
    }

    data(handle) {
      const el = document.querySelector(`[data-np-compare-item="${CSS.escape(handle)}"]`);
      try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
    }

    toggle(handle, on, box) {
      const has = this.items.some((i) => i.handle === handle);
      if (on && !has) {
        if (this.items.length >= this.max) {
          if (box) box.checked = false;
          this.hint(`Możesz porównać maksymalnie ${this.max} materace.`);
          return;
        }
        const d = this.data(handle);
        if (d) this.items.push(d);
      } else if (!on && has) {
        this.items = this.items.filter((i) => i.handle !== handle);
      }
      this.save();
      this.render();
    }

    syncBoxes() {
      const set = new Set(this.items.map((i) => i.handle));
      document.querySelectorAll('[data-np-compare-toggle]').forEach((b) => { b.checked = set.has(b.value); });
    }

    render() {
      const n = this.items.length;
      this.tray.classList.toggle('is-visible', n > 0);
      this.count.textContent = `${n} z ${this.max}`;
      this.go.disabled = n < 2;
      this.go.textContent = n < 2 ? 'Wybierz min. 2' : `Porównaj (${n})`;
      const slots = [];
      this.items.forEach((i) => slots.push(`<li><img src="${i.image}" alt="${this.esc(i.title)}" width="52" height="52"><button type="button" data-remove="${this.esc(i.handle)}" aria-label="Usuń ${this.esc(i.title)}">&times;</button></li>`));
      for (let k = n; k < this.max; k += 1) slots.push('<li class="np-cmp-tray__slot" aria-hidden="true"></li>');
      this.list.innerHTML = slots.join('');
      this.syncBoxes();
    }

    hint(text) {
      clearTimeout(this.hintTimer);
      this.querySelector('.np-cmp-hint')?.remove();
      const p = document.createElement('p');
      p.className = 'np-cmp-hint';
      p.setAttribute('role', 'status');
      p.textContent = text || 'Zaznacz „Porównaj” przy co najmniej dwóch materacach.';
      this.appendChild(p);
      this.hintTimer = setTimeout(() => p.remove(), 3200);
    }

    esc(v) {
      return String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    open() {
      const items = this.items;
      const scale = (v) => (v ? `<span class="np-scale" style="max-width:120px">${[1, 2, 3, 4, 5].map((k) => `<i class="${k <= v ? 'is-on' : ''}"></i>`).join('')}</span>` : '');
      const yes = (v) => (v === true ? '<span class="np-cmp-yes">Tak</span>' : v === false ? 'Nie' : '–');
      const rows = [
        ['Rodzaj', (i) => i.typ],
        ['Twardość', (i) => (i.twardosc ? `${this.esc(i.twardosc)}${scale(i.skala)}` : null), true],
        ['Wysokość', (i) => i.wysokosc],
        ['Strefy podparcia', (i) => (i.strefy === 0 ? 'brak' : i.strefy)],
        ['Konstrukcja', (i) => i.konstrukcja],
        ['Pokrowiec', (i) => i.pokrowiec],
        ['Stelaż regulowany', (i) => (i.stelaz === null || i.stelaz === undefined ? null : yes(i.stelaz)), true],
        ['Gwarancja', (i) => i.gwarancja],
        ['Wyrób medyczny', (i) => yes(!!i.medyczny), true],
        ['Produkcja', (i) => i.produkcja],
        ['Certyfikaty', (i) => i.certyfikaty],
      ];
      const head = `<thead><tr><th scope="col"></th>${items.map((i) => `<td><div class="np-cmp-prod"><a class="np-cmp-prod__img" href="${i.url}"><img src="${i.image}" alt="" loading="lazy"></a><span class="np-cmp-prod__title">${this.esc(i.title)}</span><span class="np-cmp-prod__price">${this.esc(i.price)}</span><a class="np-cmp-prod__link" href="${i.url}">Zobacz materac</a></div></td>`).join('')}</tr></thead>`;
      const body = rows.map(([label, get, html]) => {
        const vals = items.map((i) => { const v = get(i); return v === null || v === undefined || v === '' ? '–' : (html ? v : this.esc(v)); });
        const same = vals.every((v) => v === vals[0]);
        return `<tr class="${same ? 'is-same' : ''}"><th scope="row">${label}</th>${vals.map((v) => `<td>${v}</td>`).join('')}</tr>`;
      }).join('');
      this.body.innerHTML = `<table class="np-cmp-table">${head}<tbody>${body}</tbody></table>`;
      this.dialog.showModal();
    }
  });
}
